import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components'

const Image = styled.a`
  background-image: url(${props => props.image});
  background-position: 50% 50%;
  background-size: cover;
  opacity: .4;
  &:hover {
    transition: all .4s ease;
    opacity: 1;
  }
  &:before {
    content: '';
  }
`

const Feature = ({href, image, heading, description, to}) =>
  <section>
    <Image
      href={href}
      image={image}
      className="image"
      alt="image"
    />
    <div className="content">
      <div className="inner">
        <h2>{heading}</h2>
        <p>{description}</p>
      </div>
    </div>
  </section>

export default Feature;
